<script lang="ts">
  import { Splide } from '@splidejs/svelte-splide';
  import { AutoScroll } from '@splidejs/splide-extension-auto-scroll';
  import '@splidejs/svelte-splide/css';
  import type { Options } from '@splidejs/splide';

  export let options: Options;
  export let autoScroll = false;
</script>

<Splide extensions={autoScroll && { AutoScroll }} {options}>
  <slot />
</Splide>
